import React from 'react';

/**
 * Mute/unmute icon styled like the provided reference:
 * - circular outline
 * - microphone
 * - when muted: diagonal slash
 *
 * Uses `currentColor` so existing button styles control the color.
 */
const MuteIcon = ({ muted = false, size = 20, className, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    style={style}
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="10" />

    {/* Microphone */}
    <path d="M12 14a2 2 0 0 0 2-2V7a2 2 0 1 0-4 0v5a2 2 0 0 0 2 2z" />
    <path d="M9 11v1a3 3 0 0 0 6 0v-1" />
    <path d="M12 15v3" />

    {/* Mute slash */}
    {muted ? <path d="M7 7l10 10" /> : null}
  </svg>
);

export default MuteIcon;


